var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, DialogContent, DialogFooter, DialogHeader, useToast } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { object, string } from 'yup';
import { CancelButton, FormDialog, SubmitButton, TextField } from 'shared/domains/forms';
import { globalMarket } from 'shared/domains/markets/config';
import { MarketField } from './MarketField';
import { MutationError } from './MutationError';
import { useCreateCompany } from './useCreateCompany';
export function CreateDialog(props) {
    const { onClose, onCreate } = props;
    const { addToast } = useToast();
    const { createCompany } = useCreateCompany();
    const requiredErrorText = t({
        message: 'This field is required',
        comment: 'Add company dialog - Required field text',
    });
    const schema = object().shape({
        companyName: string().required(requiredErrorText),
        marketCode: string().min(2, requiredErrorText).required(requiredErrorText),
    });
    const handleSubmit = (values) => __awaiter(this, void 0, void 0, function* () {
        const { marketCode, companyName } = values;
        try {
            const transformedValues = {
                companyName,
                marketCode: marketCode === globalMarket.code ? 'de' : marketCode,
            };
            const { id: accountId } = yield createCompany(transformedValues);
            onCreate(accountId);
        }
        catch (error) {
            addToast({
                appearance: 'danger',
                title: t({
                    message: 'Could not create company',
                    comment: 'Add company dialog - Error toast title',
                }),
            });
        }
    });
    return (<FormDialog size="md" initialValues={{ companyName: '', marketCode: '' }} validationSchema={schema} onClose={onClose} onSubmit={handleSubmit}>
      <DialogHeader icon={<Falcon icon="building"/>} title={t({
            message: 'Add company',
            comment: 'Add company dialog - Dialog title',
        })}/>

      <DialogContent>
        <Box flexDirection="column" gap="xl">
          <Box flexDirection="column" gap="sm">
            <TextField stretch name="companyName" label={t({ message: 'Company name', comment: 'Add company dialog - Company name input label' })}/>
          </Box>

          <MarketField />

          <MutationError />
        </Box>
      </DialogContent>

      <DialogFooter>
        <CancelButton size="small" onClick={onClose}>
          <Trans comment="Add company dialog - Cancel button label">Cancel</Trans>
        </CancelButton>
        <SubmitButton size="small">
          <Trans comment="Add company dialog - Create company button label">Create company</Trans>
        </SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
